import AppRoute from "models/AppRoute"

const MaintenanceRoute = new AppRoute({
    route: "/maintenance",
    navbar: true,
    authRequired: true,
})

export default MaintenanceRoute
